(function () {
	if (typeof window.Splide === 'undefined' || !('IntersectionObserver' in window)) return;

	var proto = window.Splide.prototype;
	var originalMount = proto.mount;
	var STATE_CREATED = 1;
	var pending = new Map();
	var autoplayInstances = new WeakMap();
	var scrollTriggerTimer = null;

	function refreshScrollTrigger() {
		if (!window.ScrollTrigger || typeof window.ScrollTrigger.refresh !== 'function') return;
		clearTimeout(scrollTriggerTimer);
		scrollTriggerTimer = setTimeout(function () {
			window.ScrollTrigger.refresh();
		}, 200);
	}

	function isNearViewport(root) {
		var rect = root.getBoundingClientRect();
		if (!rect.width && !rect.height) return false;
		var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
		return rect.top < viewportHeight * 2 && rect.bottom > -viewportHeight;
	}

	function clearPending(splide) {
		splide.__mmMountArgs = null;
		if (pending.get(splide.root) === splide) {
			pending.delete(splide.root);
			mountObserver.unobserve(splide.root);
		}
	}

	var autoplayObserver = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			var splide = autoplayInstances.get(entry.target);
			var autoplay = splide && splide.Components && splide.Components.Autoplay;
			if (!autoplay) return;

			if (!entry.isIntersecting && !autoplay.isPaused()) {
				splide.__mmPausedOffscreen = true;
				autoplay.pause(false);
			} else if (entry.isIntersecting && splide.__mmPausedOffscreen) {
				splide.__mmPausedOffscreen = false;
				autoplay.play();
			}
		});
	});

	function watchAutoplay(splide) {
		if (!splide.options || !splide.options.autoplay) return;
		var root = splide.root;
		autoplayInstances.set(root, splide);
		autoplayObserver.observe(root);
		splide.on('destroy', function () {
			if (autoplayInstances.get(root) === splide) {
				autoplayInstances.delete(root);
				autoplayObserver.unobserve(root);
			}
		});
	}

	function finishMount(splide, args) {
		clearPending(splide);
		originalMount.apply(splide, args);
		watchAutoplay(splide);
		return splide;
	}

	function mountDeferred(splide) {
		var args = splide.__mmMountArgs;
		if (splide.state.is(STATE_CREATED)) {
			finishMount(splide, args);
		} else {
			clearPending(splide);
		}
	}

	var mountObserver = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (!entry.isIntersecting) return;
			var splide = pending.get(entry.target);
			if (!splide) return;
			mountDeferred(splide);
			refreshScrollTrigger();
		});
	}, { rootMargin: '100% 0px 100% 0px' });

	proto.mount = function () {
		var previous = pending.get(this.root);
		if (previous && previous !== this) clearPending(previous);

		if (this.state.is(STATE_CREATED) && !this.__mmMountArgs && !isNearViewport(this.root)) {
			this.__mmMountArgs = arguments;
			pending.set(this.root, this);
			mountObserver.observe(this.root);
			return this;
		}

		return finishMount(this, arguments);
	};

	['go', 'add', 'remove'].forEach(function (method) {
		var original = proto[method];
		if (typeof original !== 'function') return;
		proto[method] = function () {
			if (this.__mmMountArgs) mountDeferred(this);
			return original.apply(this, arguments);
		};
	});

	['index', 'length'].forEach(function (key) {
		var descriptor = Object.getOwnPropertyDescriptor(proto, key);
		if (!descriptor || typeof descriptor.get !== 'function') return;
		Object.defineProperty(proto, key, {
			configurable: true,
			enumerable: descriptor.enumerable,
			get: function () {
				if (this.__mmMountArgs) mountDeferred(this);
				return descriptor.get.call(this);
			},
			set: descriptor.set
		});
	});
})();
